import { Variants } from "framer-motion";

// 1. The Main Container
export const containerVariants: Variants = {
  hidden: { 
    opacity: 0, 
    y: 40, 
    scale: 0.98 
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 100,
      damping: 20,
      delay: 0.6,
      when: "beforeChildren",
      staggerChildren: 0.2,
    },
  },
};

export const badgeVariants: Variants = {
  hidden: { 
    opacity: 0, 
    scale: 0.8, 
    x: -10 
  },
  show: {
    opacity: 1,
    scale: 1,
    x: 0,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
    },
  },
};